import React from 'react';

export const IconCloseMenu = ({ width, height }) => {

  const styles = {
    frame: {
      display: 'inline-block',
      width,
      height
    },
    container: {
      display: 'inline-block',
    },
    svg: {
      width: '100%'
    }
  }

  return (
    <div style={styles.frame}>
      <div style={styles.container} className="menu-button-icon-bubbles">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" style={styles.svg}>
          <g
            className="nc-icon-wrapper"
            strokeLinecap="square"
            strokeLinejoin="miter"
            strokeWidth="1.5"
            fill="#331e11"
            stroke="#331e11"
            >
            <line
              fill="none"
              stroke="#331e11"
              strokeMiterlimit="10"
              x1="27"
              y1="5"
              x2="5"
              y2="27"
            />
            <line
              fill="none"
              stroke="#331e11"
              strokeMiterlimit="10"
              x1="27"
              y1="27"
              x2="5"
              y2="5"
              />
          </g>
        </svg>
      </div>
    </div>
  )
};

